import { cn } from '@/src/helpers';
import { Flex } from '../../../ui';

type SignRightSideBodyProps = {
  children: React.ReactNode;
  className?: string;
};

export const SignRightSideBody = ({
  children,
  className,
}: SignRightSideBodyProps) => {
  return <Flex className={cn('max-w-md', className)}>{children}</Flex>;
};
